import { motion, type HTMLMotionProps } from "framer-motion";
import { useMemo } from "react";
import { useMotionPrefs } from "./MotionProvider";
import { interactive } from "./variants";

type InteractiveProps = Omit<
  HTMLMotionProps<"button">,
  "variants" | "initial" | "animate" | "whileHover" | "whileTap" | "whileFocus"
> & {
  as?: "button" | "a" | "div" | "li" | "article";
  lift?: number;
  scale?: number;
  press?: number;
  href?: string;
};

export function Interactive({
  as = "button",
  lift,
  scale,
  press,
  children,
  ...rest
}: InteractiveProps) {
  const { reduce } = useMotionPrefs();
  const Tag = motion[as] as typeof motion.button;

  const variants = useMemo(
    () => interactive({ lift, scale, press }, reduce),
    [lift, scale, press, reduce],
  );

  return (
    <Tag
      variants={variants}
      initial="rest"
      animate="rest"
      whileHover="hover"
      whileFocus="hover"
      whileTap="press"
      {...rest}
    >
      {children}
    </Tag>
  );
}
